import React from 'react';

const H4H = () => {
  return (
    <div>
      <h1>H4H Page</h1>
      <p>Welcome to the H4H page!</p>
    </div>
  );
};

export default H4H;
